import { getLanguage } from '../languages';

enum Units {
    'KG' = 'KG',
    'M' = 'M'
}

export class Unit {
    private static locale = getLanguage();

    private static KGFormatter = new Intl.NumberFormat(Unit.locale,
        {maximumFractionDigits: 2});
    private static MFormatter = new Intl.NumberFormat(Unit.locale,
        {maximumFractionDigits: 2});

    static readonly UNIT = Units;

    static reverseFormat(formatter: Intl.NumberFormat, value: any): number {
        const parts = formatter.formatToParts(value);
        const fractionPart = parts.find((part) => part.type === 'fraction')?.value;
        let integerPart = '';
        parts.forEach((part) => part.type === 'integer' ? integerPart += part.value : '');
        return +(integerPart + (fractionPart ? '.' + fractionPart : ''));
    }

    static formatValue(unit: string, value: string | number): string {
        if (unit === Units.KG) {
            return this.KGFormatter.format(this.reverseFormat(this.KGFormatter, value));
        } else if (unit === Units.M) {
            return this.MFormatter.format(this.reverseFormat(this.MFormatter, value));
        }
    }

    static formatToUnit(unit: string, value: string | number): string {
        if (unit === Units.KG) {
            return this.KGFormatter.format(+value / 1000);
        } else if (unit === Units.M) {
            return this.MFormatter.format(+value / 1000);
        }
    }

    static formatFromUnit(unit: string, value: string | number): number {
        if (unit === Units.KG) {
            return this.reverseFormat(this.KGFormatter, value) * 1000;
        } else if (unit === Units.M) {
            return this.reverseFormat(this.MFormatter, value) * 1000;
        }
    }
}
